import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useLanguage();

  const faqData = t('faq');

  return (
    <section className="bg-[#0a0a0b] py-20">
      <div className="max-w-3xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            {faqData?.title || 'Frequently Asked Questions'}
          </h2>
          <p className="text-gray-400 mt-4">
            {faqData?.subtitle || 'Common questions about the AIConneqtors platform'}
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {Array.isArray(faqData?.questions) && faqData.questions.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-800 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between p-5 text-left bg-[#0d1117] hover:bg-[#1a1a1f] transition-colors"
              >
                <span className="text-white font-medium pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 text-teal-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="p-5 pt-0 bg-[#0d1117]">
                  <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
